import React from 'react';
import { OrgQueryKeys } from '../../../../../api/config';
import { useOrganizationQuery } from '../../../../../api/queries/use-organization-query';
import { stopHasCargo } from '../../../../../constants/constants';
import { Medication, Stop } from '../../../../../types';
import { getPairedStop } from '../../../../../utils/data-mapping-utils';
import { createAgisticsSelectElements } from '../../../../shared/agistics-select';
import { LoadableComponent } from '../../../../shared/loadable-component';
import { AgisticsMultiSelect } from '../../../../shared/multi-select/agistics-multi-select';
import { useDraftLoadContext } from '../../../hooks/draft-load-context';
import { getMedicationsTagStyle, getSingleColorTagStyle } from '../../../utils/drafts-loads-utils';

interface EditableStopMedicationProps {
    stop: Stop;
}
export const EditableStopMedication = (props: EditableStopMedicationProps) => {
    const { stop } = props;
    const { editedLoad, onEditedLoadChanged } = useDraftLoadContext();
    const { data: medications = [], isLoading } = useOrganizationQuery<Medication[]>(OrgQueryKeys.medications);
    const items = createAgisticsSelectElements(medications, m => m.name);

    function onChange(newVals: number[]) {
        const pairedStop = getPairedStop(editedLoad, stop);

        onEditedLoadChanged({
            ...editedLoad,
            stops: editedLoad.stops.map(x => {
                if (x.sequence === stop.sequence || x.sequence === pairedStop?.sequence) {
                    return { ...x, medicationIds: newVals }
                } else {
                    return x;
                }
            })
        })
    }

    function optionsStyleFn(optionId: number) {
        return getSingleColorTagStyle(optionId, medications);
    }

    function selectedStyleFn(optionIds: number[]) {
        return getMedicationsTagStyle(optionIds, medications);
    }

    if (isLoading || !stopHasCargo(stop)) {
        return null;
    }

    return (
        <LoadableComponent isLoading={isLoading}>
            <AgisticsMultiSelect
                items={items}
                selectedIds={stop.medicationIds || []}
                setSelectedIds={onChange}
                styleForOptionsFn={optionsStyleFn}
                styleForSelectionsFn={selectedStyleFn}
                smallText={true}
            />
        </LoadableComponent>
    )
};